<user-navigation></user-navigation>

<div class="container-fluid">
  <div id="top"></div>
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4 profile-side-bar">
            <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mb-5 mb-md-0">
                            <div id="page-redirection">
                                <a routerLink="/user/profile">
                                    <img src="../../../../assets/images/arrows/back_arrow.png">
                                    Back to Account
                                </a>
                            </div>
                            <h3 class="display-4 box-title mt-4 mt-md-4">Subscription</h3><br>

                            <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                              <button type="button" class="close" data-dismiss="alert">&times;</button>
                              Plan successfully cancelled.
                            </div>

                            <div class="subscription mt-md-5 mt-5">
                                <h6 class="font-weight-bold">Take a Breath Subscription</h6>
                                <p>NZD ${{ subscriptionAmount }} per/year
                                  <a *ngIf="!cancel_date" (click)="resetForm()" class="pull-right cancel-subscription"  data-toggle="modal" data-target="#cancelModalCenter">Cancel Plan</a>
                                </p>
                                <span *ngIf="cancel_date">Subscription plan was cancelled on {{cancel_date * 1000 | date:'dd/MM/yyyy':'+1200'}}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>

<!-- Modal -->
<div class="modal fade" id="cancelModalCenter" tabindex="-1" role="dialog" aria-labelledby="cancelModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="cancelModalTitle">Cancel Plan</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="cancelForm" (ngSubmit)="onCancelPlan()">
        <div class="modal-body">
          Are you sure to cancel your plan?
          Please enter your password below to continue cancellation.
          <input  type="password" formControlName="password" class="form-control mt-3" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Enter password">
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required</div>
            <div *ngIf="f.password.errors.invalid">Password is incorrect</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="pull-right btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
          <button type="submit" class="pull-right btn btn-danger btn-sm">Cancel Plan
            <img src="../../../../assets/images/loader.gif" *ngIf="loading"></button>
        </div>
      </form>
    </div>
  </div>
</div>

<footer-main></footer-main>
